/*
 * @Description: 各专业转入转出情况
 * @Author: lisenlin
 * @Date: 2021-08-27 09:40:30
 * @LastEditors: lisenlin
 * @LastEditTime: 2021-08-31 10:49:00
 */
import React, { useState } from 'react'
import echarts from "echarts/lib/echarts";
import Echarts from '../../../components/common/Echarts/index'
import css from '../index.css'
import { Select, Radio, Spin } from 'antd'
import createUuid from '../../../utils/createUuid';
import { userLogin } from '../../../actions/login';

export default function ChangeMajorByCollege(props) {
    const [type, setType] = useState('zr');  // 转入转出类型  zr：转入，zc：转出
    const [bmid, setBmid] = useState('');   // 当前选择的学院  默认是全部学院 ''
    const [loading, setLoading] = useState(false);  //是否加载中
    let { xyList = [], staticList = [], queryList } = props;

    /** 切换学院刷新数据 */
    const onHandelBm = (value) => {
        setLoading(true);
        setBmid(value);
        queryList(value,type==='zc'?true:false,()=>{
            setLoading(false)
        })
    }

    /** 切换转入转出类型刷新数据 */
    const onHandelType = (value) => {
        setLoading(true);
        setType(value);
        queryList(bmid,value==='zc'?true:false,()=>{
            setLoading(false)
        })
    }

    /**
     * 渲染专业转入转出的option
     * @param {*} list 数据
     * @returns option
     */
    const getBarOption = (list) => {
        let zyList = [], countList = [];
        list.length > 0 && list.map(item => {
            zyList.push(item.ZYMC);
            countList.push(item.CS);
        })
        let barColor = [
            {offset: 0, color: '#5BBDFF'},
            {offset: 0.5, color: '#5AA9FF'},
            {offset: 1, color: '#4C90FF'}
        ]
        if(type==='zc') {
            barColor = [
                {offset: 0, color: '#B8E8DE'},
                {offset: 0.5, color: '#01C8A8'},
                {offset: 1, color: '#00CFBB'}
            ]
        }
        return {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    crossStyle: {
                        color: '#999'
                    }
                }
            },
            legend: {
                show: false
            },
            grid: {
                top: 20,  //坐标轴距离上边间距
                bottom: 80,
                left: 30,
                right: 30,

            },
            xAxis: [
                {
                    type: 'category',
                    data: zyList,
                    axisPointer: {
                        type: 'shadow'
                    },
                    boundaryGap: true,
                    axisTick: {
                        show: false,   //不显示刻度
                    },
                    axisLabel: {
                        show: true,
                        rotate: 45,    //刻度标签旋转  0-90 度
                        formatter: function (value) {
                            return value.length > 7 ? value.substring(0, 7) + '...' : value;
                        }
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    // name: '人数',
                    // min: 0,
                    // max: 250,
                    // interval: 50,
                    // axisLabel: {
                    //     formatter: '{value} 人'
                    // }
                    axisTick: {
                        show: false,  //不显示刻度
                    }
                }
            ],
            series: [
                {
                    name: '人数',
                    type: 'bar',
                    data: countList,
                    barMaxWidth: 30,    //柱体的最大宽度
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 0, 1,
                                barColor
                            ),
                            barBorderRadius: [5, 5, 0, 0],
                            label: {      //设置柱状图头部显示数据
                                show: true,
                                position: "outside"
                            },
                        }
                    },
                },
            ]
        }
    }
    return (
        <div className={css.cardWarp}>
            <div className={css.warpFlex}>
                <div className={css.title}>全校各专业{type === 'zc' ? '转出' : '转入'}情况</div>
                <div className={css.rightFilter}>
                    <Select style={{ width: '200px' }} value={bmid} className={css.rightFilter_select} onChange={(value)=>{onHandelBm(value)}}> 
                        {xyList.length&&xyList.map(item=>{
                            return (
                                <Select.Option value={item.VALUE}>
                                    {item.LABEL}
                                </Select.Option>
                            )
                        })}
                    </Select>
                    <Radio.Group value={type} buttonStyle="solid" onChange={(e => { onHandelType(e.target.value) })}>
                        <Radio.Button value="zr">转入</Radio.Button>
                        <Radio.Button value="zc">转出</Radio.Button>
                    </Radio.Group>
                </div>
            </div>
            <Spin spinning={loading}>
                <Echarts
                    key={createUuid()}
                    style={{ height: '400px', width: '100%' }}
                    option={getBarOption(staticList)}
                />
            </Spin>
        </div>
    )
}


// WEBPACK FOOTER //
// ./components/changeMajorStaic/changeMajorByCollege/index.js